var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"darkcmpbk",attrs:{"id":"vapp"}},[_c('v-row',{staticClass:"menu-bar-row"},[_c('v-col',{attrs:{"cols":"12"}},[_c('brandbar')],1)],1),_c('v-main',{attrs:{"id":"main"}},[_c('Transition',{attrs:{"name":"fade-transition","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }